/**
 * @internal
 */
export var status = function (response) {
    if (response.ok) {
        return Promise.resolve(response);
    }
    else {
        return Promise.reject(response);
    }
};
